import type { QuotationCloneVersionRequestModel } from "models/axiosModel"

/** One chip in the Create new version popup, from generic-data `quotation_version_reason_type`. */
export interface IVersionReasonType {
	id: number
	name: string
}

export const readVersionReasonTypes = (genericResponse: any): IVersionReasonType[] => {
	const list = genericResponse?.status ? genericResponse?.data?.[0]?.quotation_version_reason_type : null
	return (Array.isArray(list) ? list : [])
		.map((item: any) => ({
			id: Number(item?.quotation_version_reason_type_id),
			name: String(item?.quotation_version_reason_type_name ?? "").trim(),
		}))
		.filter((item) => Number.isInteger(item.id) && item.id > 0 && item.name)
}

const isOtherReason = (reason: IVersionReasonType): boolean => reason.name.toLowerCase() === "other"

/** The note is optional, except when "Other" is one of the selected reasons. */
export const isVersionNoteRequired = (selectedIds: number[], reasonTypes: IVersionReasonType[]): boolean =>
	reasonTypes.some((reason) => selectedIds.includes(reason.id) && isOtherReason(reason))

export const canSubmitVersionReason = (
	selectedIds: number[],
	note: string,
	reasonTypes: IVersionReasonType[],
): boolean => selectedIds.length > 0 && (!isVersionNoteRequired(selectedIds, reasonTypes) || note.trim().length > 0)

export const toggleVersionReason = (selectedIds: number[], reasonId: number): number[] =>
	selectedIds.includes(reasonId) ? selectedIds.filter((id) => id !== reasonId) : [...selectedIds, reasonId]

/** clone-version body: only the reasons and note; the backend copies everything else from the parent. */
export const buildCloneVersionPayload = (selectedIds: number[], note: string): QuotationCloneVersionRequestModel => {
	const trimmedNote = note.trim()
	return {
		version_reasons: Array.from(new Set(selectedIds)).map((id) => ({ quotation_version_reason_type_id: id })),
		...(trimmedNote ? { version_note: trimmedNote } : {}),
	}
}
